// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c4-4";
export var closeButton = "_c4-6";
export var dismissButton = "_c4-3";
export var editImageWithAiContainer = "_c4-8";
export var imageUploadWrapper = "_c4-7";
export var misspelledWord = "_c4-5";
export var spellCheckContainer = "_c4-2";
export var spin = "_c4-1";
export var spinning = "_c4-0";